import { DateTime, Duration } from "luxon";

export const isPastDue = (item: {
  dueDate?: string | null | undefined;
  completedAt?: string | null | undefined;
}): boolean => {
  if (!item.dueDate || item.completedAt) {
    return false;
  }
  return isInPast(item.dueDate);
};

export const isInPast = (dateStr: string): boolean => {
  return (
    DateTime.fromISO(dateStr).toFormat("yyyy-MM-dd") <
    DateTime.now().toFormat("yyyy-MM-dd")
  );
};

export const isDateTimeInPast = (dateStr: string): boolean => {
  return DateTime.fromISO(dateStr) < DateTime.now();
};

export const msToTimestamp = (ms: number): string => {
  const hours = Math.floor(ms / 3600000);
  const minutes = Math.floor((ms % 3600000) / 60000);
  const seconds = Math.floor((ms % 60000) / 1000);

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0",
  )}:${String(seconds).padStart(2, "0")}`;
};

export const getBrowserTimezone = (): string => {
  return new Date()
    .toLocaleTimeString("en-us", { timeZoneName: "short" })
    .split(" ")[2];
};

export const formatDuration = (ms: number): string => {
  const duration = Duration.fromMillis(ms);
  const hours = Math.floor(duration.as("hours"));
  const minutes = Math.floor(duration.as("minutes") % 60);
  if (hours === 0) {
    return `${ms > 0 ? Math.max(minutes, 1) : 0}m`;
  }
  return `${hours}h ${minutes}m`;
};

export const formatMinutesToHumanReadable = (minutes: number): string => {
  const roundedMinutes = Math.max(0, Math.round(minutes));

  const duration = Duration.fromObject({ minutes: roundedMinutes })
    .shiftTo("days", "hours", "minutes")
    .normalize();

  const parts: string[] = [];
  const days = Math.floor(duration.days);
  const hours = Math.floor(duration.hours);
  const mins = Math.floor(duration.minutes);

  if (days > 0) {
    parts.push(`${days} ${days === 1 ? "day" : "days"}`);
  }
  if (hours > 0) {
    parts.push(`${hours} ${hours === 1 ? "hour" : "hours"}`);
  }
  if (mins > 0 || parts.length === 0) {
    parts.push(`${mins} ${mins === 1 ? "minute" : "minutes"}`);
  }

  return parts.join(" ");
};
